;
(function () {
  'use strict';

  var MAX_COST_CENTER_TO_VIEW;


  $.fn.select2.amd.define('select2/data/CustomDataAdapter', [
      'select2/data/array',
      'select2/utils'
    ],
    function (ArrayAdapter, Utils) {

      function CustomDataAdapter($element, options) {
        this.$element = $element;
        CustomDataAdapter.__super__.constructor.call(this, $element, options);
      }
      Utils.Extend(CustomDataAdapter, ArrayAdapter);

      CustomDataAdapter.prototype.query = function (params, callback) {
        var data,
          costCentertype,
          allResults,
          results,
          selectedCostCenter;

        data = {
          results: []
        };

        costCentertype = this.$element.data().type;
        MAX_COST_CENTER_TO_VIEW = EG.Users.Utils.getMaxCostCentreToView(costCentertype);
        selectedCostCenter = _.findWhere(CustomDataAdapter.data, {
          type: costCentertype
        });
        allResults = selectedCostCenter.collection.toJSON();

        if (params.term) {
          results = [];
          for (var i = 0; i < allResults.length; i++) {
            if (allResults[i].label.toLowerCase().indexOf(params.term.toLowerCase()) != -1) {
              results.push({
                id: allResults[i].id,
                text: allResults[i].label
              });
            }
          }
        } else {
          results = _.map(allResults, function (result) {
            return {
              id: result.id,
              text: result.label
            }
          });
        }

        data.results = results.slice(0, MAX_COST_CENTER_TO_VIEW);

        callback(data);
      };

      CustomDataAdapter.prototype.processResults = function (data) {
      }

      return CustomDataAdapter;
    }
  );

  $.fn.select2.amd.define('select2/data/CustomDataAdapterWithAjax', [
      'select2/data/array',
      'select2/utils'
    ],
    function (ArrayAdapter, Utils) {

      function CustomDataAdapterWithAjax($element, options) {
        CustomDataAdapterWithAjax.__super__.constructor.call(this, $element, options);
      }
      Utils.Extend(CustomDataAdapterWithAjax, ArrayAdapter);

      CustomDataAdapterWithAjax.prototype.query = function (params, callback) {
        var data,
          costCentertype,
          results,
          selectedCostCenter,
          options,
          transformResults,
          url;

        data = {
          results: []
        };

        options = this.options.options;
        options.queryLabel = options.queryLabel || 'label';
        options.label = options.label || 'label';

        transformResults = options.transformResults || function (result) {
          return {
            id: result.id,
            text: result[options.label]
          };
        };

        costCentertype = this.$element.data().type || this.$element.data().id;
        MAX_COST_CENTER_TO_VIEW = EG.Users.Utils.getMaxCostCentreToView(costCentertype);
        selectedCostCenter = _.findWhere(CustomDataAdapterWithAjax.data, {
          type: costCentertype
        });
        results = selectedCostCenter.collection.toJSON();

        if (!params.term) {
          data.results = _.map(results, transformResults);

          data.results = data.results.slice(0, MAX_COST_CENTER_TO_VIEW);

          return callback(data);
        }

        if (results.length < MAX_COST_CENTER_TO_VIEW - 1) {
          for (var i = 0; i < results.length; i++) {
            if (results[i].label.toLowerCase().indexOf(params.term.toLowerCase()) != -1) {
              data.results.push({
                id: results[i].id,
                text: results[i][options.label]
              });
            }
          }

          data.results = data.results.slice(0, MAX_COST_CENTER_TO_VIEW);

          return callback(data);
        }

        url = selectedCostCenter.collection.url() + '&' + options.queryLabel + '=' + params.term.trim();

        $.get(url).then(function (response) {
          var results;
          results = response[options.responseKey] || response;

          data.results = _.map(results, transformResults);
          data.results = data.results.slice(0, MAX_COST_CENTER_TO_VIEW);

          return callback(data);
        });
      };

      return CustomDataAdapterWithAjax;
    }
  );
})();
